/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPavillonInformationQuery = gql`
  query GetSimulationPavillonInformationQuery {
    getSimulationPavillonInformation_simulation_pavillon_information {
      customer {
 emails {
 value  
} 
phones {
 internationalCode  
number  
isMobile  
} 
addresses {
 fields  
zipCode  
city  
} 
}
      grantees {
 id  
type  
CSPs {
 label  
categoryLvl1CSPExternalId  
} 
socialSecurities {
 regime  
} 
birthDate  
isTNS  
firstName  
lastName  
civility  
}
    }
  }
`;

export default GetSimulationPavillonInformationQuery;
